<template>
  <div class="products-table">
    <div class="row filters mb-4">
      <div class="col-xl-2 col-md-4 col-sm-6">
        <b-field>
          <b-select
            @input="load"
            v-model="filters.family"
            placeholder="Filtrar por Família"
          >
            <option :value="undefined">Todas</option>
            <option
              v-for="family in families"
              :key="family.id"
              :value="family.name"
              >{{ family.name }}</option
            >
          </b-select>
        </b-field>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6">
        <app-input
          @input="onInput"
          v-model="filters.term"
          placeholder="Pesquisar"
        ></app-input>
      </div>
    </div>

    <b-table
      :data="data"
      :loading="loading"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      aria-next-label="Próxima Página"
      aria-previous-label="Página Anterior"
      aria-page-label="Página"
      aria-current-label="Página Atual"
    >
      <template slot-scope="props">
        <b-table-column field="id" label="#" numeric>{{
          props.row.id
        }}</b-table-column>

        <b-table-column field="active" label="Ativo">
          <b-icon
            v-if="props.row.active"
            size="is-small"
            icon="check"
            type="is-success"
          ></b-icon>
          <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
        </b-table-column>

        <b-table-column field="ean_code" label="Código EAN">{{
          props.row.ean_code
        }}</b-table-column>

        <b-table-column field="code" label="Código">{{
          props.row.code
        }}</b-table-column>

        <b-table-column field="name" label="Nome">{{
          props.row.name
        }}</b-table-column>

        <b-table-column field="created_at" label="Data Criação">{{
          props.row.created_at
        }}</b-table-column>
        <b-table-column field="created_at" label="Data Atualização">{{
          props.row.created_at
        }}</b-table-column>

        <b-table-column label="Opções">
          <button
            @click="edit(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Editar'"
          >
            <b-icon size="is-small" icon="pencil" />
          </button>
          <button
            @click="onClickDeleteProduct(props.row.id)"
            v-app-button.icon-only
            v-tooltip.bottom="'Excluir'"
            color="danger"
          >
            <b-icon size="is-small" icon="delete" />
          </button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nenhum registro encontrado.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import ProductService from '@/services/product.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import moment from 'moment';

import debounce from 'lodash/debounce';

export default {
  name: 'products-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      filters: { family: '' },
      families: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      ProductService.search({
        page: this.page,
        perPage: this.perPage,
        ...this.filters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data.map(({ created_at, updated_at, ...rest }) => ({
            created_at: moment(created_at).format('LL'),
            updated_at: moment(updated_at).format('LL'),
            ...rest,
          }));
        })
        .catch(() => this.toastify('Erro ao carregar Produtos.', 'error'))
        .finally(() => (this.loading = false));
    },
    onInput: debounce(function () {
      this.load();
    }, 400),
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteProduct(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Produto',
        message:
          'Tem certeza que deseja <b>excluir</b> este Produto? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Produto',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteProduct(id),
      });
    },
    deleteProduct(id) {
      ProductService.delete(id)
        .then(() => {
          this.toastify('Produto excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Produto.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    loadFamilies() {
      ProductService.getFamilies().then(({ data }) => {
        this.families = data.map((family, id) => ({ id, name: family }));
      });
    },
  },
  mounted() {
    if (localStorage.productsTableTerm) {
      this.filters = {
        ...this.filters,
        term: localStorage.productsTableTerm,
      };
    }

    this.filters = {
      ...this.filters,
      family: localStorage.productsTableFamily || undefined,
    };

    this.load();
    this.loadFamilies();
  },
  watch: {
    'filters.family': (newValue) => {
      localStorage.productsTableFamily = newValue || '';
    },
    'filters.term': (newValue) => {
      localStorage.productsTableTerm = newValue;
    },
  },
};
</script>
